module.exports = __webpack_public_path__ + "img/1522759209.57481b26.jpg";